import {ThreePortableEquipment} from '../ThreePortableEquipment';

export class ThreeMicrowaveEquipment extends ThreePortableEquipment {

}